module.exports = "/_next/static/images/plane-duotone-0156a4449f1ed3650955d0b5519becac.svg";